export default function (instance) {
  return {
    abortVisit(visitId) {
      return instance.delete(`/visits/delete/${visitId}`);
    },
    registerVisit(payload) {
      return instance.post("/visits/register", payload);
    },
    getVisits(clientId) {
      return instance.get(`/visits/get/all/${clientId}?records=100`);
    },
  };
}
